import { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'BAGA nedir?',
      answer: 'BAGA, yüzlerce hisse senedini gerçek zamanlı olarak tarayan ve karmaşık piyasa verilerini sade alım–satım-izleme kararlarına dönüştüren bir fintech ürünüdür. Kullanıcılar, canlı yayın sayfası üzerinden bu kararları anlık olarak takip edebilir.',
    },
    {
      question: 'Kararlar ne sıklıkla güncellenir?',
      answer: 'BAGA, piyasa verilerini sürekli olarak analiz eder ve kararları gerçek zamanlı olarak günceller. Yayın sayfasında görünen bilgiler, piyasa koşulları değiştikçe otomatik olarak yenilenir.',
    },
    {
      question: 'Bu bir alım-satım platformu mu?',
      answer: 'Hayır, BAGA bir alım-satım platformu değildir. BAGA, sadece piyasa analizleri sonucunda üretilen kararları yayınlayan bir bilgi platformudur. İşlem yapmak için ayrı bir aracı kurum hesabı kullanmanız gerekir.',
    },
    {
      question: 'Hangi hisse senetleri takip ediliyor?',
      answer: 'BAGA, Borsa İstanbul\'da işlem gören yüzlerce hisse senedini takip eder. Sistem, sürekli olarak güncellenen veri setleri ile çalışır ve en aktif hisselere odaklanır.',
    },
    {
      question: 'BAGA\'yı kullanmak için teknik bilgi gerekli mi?',
      answer: 'Hayır, BAGA\'nın en büyük avantajlarından biri sadeliğidir. Karmaşık grafik okuma veya teknik analiz bilgisine gerek yoktur. Kararlar, anlaşılır bir şekilde sunulur ve herkes tarafından kolayca takip edilebilir.',
    },
    {
      question: 'Mobil cihazlardan erişebilir miyim?',
      answer: 'Evet, BAGA tamamen tarayıcı tabanlı çalışır. Herhangi bir cihazdan (bilgisayar, tablet, telefon) tarayıcınız üzerinden erişebilirsiniz. Uygulama indirmeye gerek yoktur.',
    },
  ];

  return (
    <section id="faq" className="py-16 sm:py-24 lg:py-32 bg-dark-lighter relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-emerald/5 to-transparent"></div>
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-beige-light mb-4 sm:mb-6">
            Sıkça Sorulan Sorular
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-beige/70">
            BAGA hakkında merak ettikleriniz
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-dark-card border border-dark-border rounded-xl overflow-hidden hover:border-emerald/30 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 sm:p-6 text-left cursor-pointer"
              >
                <h4 className="text-base sm:text-lg font-semibold text-beige-light pr-4 sm:pr-8">
                  {faq.question}
                </h4>
                <i className={`ri-arrow-down-s-line text-xl sm:text-2xl text-emerald transition-transform flex-shrink-0 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-4 sm:px-6 pb-4 sm:pb-6">
                  <p className="text-sm sm:text-base text-beige/70 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-12 lg:mt-16 text-center">
          <p className="text-beige/70 mb-3 sm:mb-4 text-sm sm:text-base">Başka sorularınız mı var?</p>
          <a
            href="mailto:info@baga-tech.com"
            className="inline-flex items-center gap-2 text-emerald hover:text-emerald-light font-semibold transition-colors cursor-pointer text-sm sm:text-base"
          >
            Bize Ulaşın
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
